export default "__VITE_ASSET__BaxrGWOV__"